export function formatFoodCategory(category: string | undefined | null): string {
  if (!category) return '';
  const lower = category.toLowerCase().replace(/\s+/g, '-');
  if (lower === 'veg') return 'Vegetarian';
  if (lower === 'non-veg') return 'Non-Vegetarian';
  return category;
}
